module.exports = __webpack_public_path__ + "school/img/practiceSeparateHistoryCultureBg.d7999cd7.jpg";